import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import userHelper from '../../../helpers/user'

class List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            company: props.company
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            company: nextProps.company
        })
    }

    edit = (id) => {
        this.props.edit(id)
    }

    delete = (id) => {
        this.props.delete(id)
    }

    render() {
        return (
            <tr key={this.state.company.id}>
                <td>{this.state.company.name}</td>
                <td className='text-center'>{this.state.company.start_date} - {this.state.company.end_date}</td>
                {userHelper.hasModule('customer') ? <td className='text-center'>{this.state.company.customer_processed_items_count} db</td> : null}
                {userHelper.hasModule('bank') ? <td className='text-center'>{this.state.company.bank_processed_items_count} db</td> : null}
                {userHelper.hasModule('supplier') ? <td className='text-center'>{this.state.company.supplier_processed_items_count} db</td> : null}
                {userHelper.hasModule('cashregister') ? <td className='text-center'>{this.state.company.cashregister_processed_items_count} db</td> : null}
                {userHelper.hasModule('mixed') ? <td className='text-center'>{this.state.company.mixed_processed_items_count} db</td> : null}
                <td className='float-md-right'>
                    {userHelper.hasModule('customer') ? <Link className='btn btn-sm table-green-btn' to={`start/customer/${this.state.company.id}`} style={{marginLeft: '1px'}}>Vevő</Link> : null}
                    {userHelper.hasModule('bank') ? <Link className='btn btn-sm table-green-btn' to={`/start/bank/${this.state.company.id}`} style={{marginLeft: '1px'}}>Bank</Link> : null}
                    {userHelper.hasModule('supplier') ? <Link className={this.state.company.onlineszamla_token ? 'btn btn-sm table-green-btn' : 'btn btn-sm table-gray-btn'} to={`/start/supplier/${this.state.company.id}`} style={{marginLeft: '1px'}}>Szállító</Link> : null}
                    {userHelper.hasModule('cashregister') ? <Link className='btn btn-sm table-green-btn' to={`/start/cash-register/${this.state.company.id}`} style={{marginLeft: '1px'}}>Pénztárgép</Link> : null}
                    {userHelper.hasModule('mixed') ? <Link className='btn btn-sm table-green-btn' to={`/start/mixed/${this.state.company.id}`} style={{marginLeft: '1px'}}>Vegyes</Link> : null}
                    <a className='btn btn-sm table-green-btn' onClick={() => this.edit(this.state.company)} style={{marginLeft: '1px'}}><i className="fa fa-pencil-square-o" aria-hidden="true"/></a>
                    <a className='btn btn-sm table-green-btn' onClick={() => this.delete(this.state.company.id)} style={{marginLeft: '1px'}}><i className="fa fa-trash-o" aria-hidden="true"/></a>
                </td>
            </tr>
        )
    }
}

export default List


// WEBPACK FOOTER //
// ./src/components/company/Table/List.js